import { optionTitle_dateHeaders } from './DateHeadersOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
const lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let DateHeadersOption: LazyOption = createLazyOption(
    {
        key: 'dateHeaders',
        titleStringKey: optionTitle_dateHeaders,
        searchTermsStringKey: optionTitle_dateHeaders,
    },
    lazyFullModule,
    m => m.default
);
export default DateHeadersOption;
